export const mediaImageFilters = [
    {
        name: 'source',
        label: 'Source',
        type: 'radio',
        allow: ['type', 'user', '360', 'shares', 'public'],
        filters: [
            {
                text: 'Any',
                value: { interactive_id: null },
                mode: 'single',
            },
            {
                text: 'Interactive captures',
                value: { interactive_id: true },
                deny: [{ type: 'before_after' }, { type: 'document' }],
                mode: 'single',
            },
            {
                text: 'CMS uploads',
                value: { interactive_id: false },
                mode: 'single',
            },
        ],
    },
    {
        name: 'flags',
        label: 'Status',
        type: 'radio',
        allow: ['interactive_id', 'type', 'user', 'shares', '360', 'comments'],
        filters: [
            {
                text: 'Any',
                value: { public: null },
                mode: 'single',
            },
            {
                text: 'Public',
                value: { public: true },
                mode: 'single',
            },
            {
                text: 'Private',
                value: { public: false },
                mode: 'single',
            },
        ],
    },
    {
        name: 'other',
        label: 'Other',
        type: 'checkbox',
        allow: ['interactive_id', 'type', '360', 'comments', 'public'],
        filters: [
            {
                text: 'Shared',
                value: { shares: true },
                mode: 'multiple',
            },
            {
                text: 'My Uploads',
                value: { user: ca.user.uuid },
                mode: 'multiple',
            },
        ],
    },
];
